import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import LeadForm from "@/components/LeadForm";
import Location from "@/components/Location";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import StickyContact from "@/components/StickyContact";
import PromoBanner, { STORAGE_KEY } from "@/components/PromoBanner";

export default function Landing() {
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem(STORAGE_KEY) === "1";
    setBannerVisible(!dismissed);
  }, []);

  return (
    <main data-testid="landing-page" className="bg-[#0a0a0a] text-white">
      {bannerVisible && (
        <PromoBanner onDismiss={() => setBannerVisible(false)} />
      )}
      <Header bannerVisible={bannerVisible} />
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Stats />
      <Testimonials />
      <LeadForm />
      <Location />
      <FAQ />
      <Footer />
      <StickyContact />
    </main>
  );
}
